import { WebcastPlayerLoggingClient } from './WebcastPlayerLoggingClient';
import { WebcastPlayerLoggingService } from './WebcastPlayerLogging.Service';
const DEFAULT_KEEP_ALIVE_INTERVAL_MS = 30000;

export class WebcastKeepAliveHandler {
	private intervalId: number;
	private readonly loggingClient: WebcastPlayerLoggingClient;

	constructor(
		private readonly WebcastPlayerLogging: WebcastPlayerLoggingService,
		private readonly sessionId: string,
		private readonly webcastId: string,
		private readonly runNumber: number) {
		this.loggingClient = this.WebcastPlayerLogging.getClient(webcastId, runNumber);
	}

	public startKeepAlive(): void {
		if (this.intervalId) {
			return;
		}

		this.intervalId = window.setInterval(() => {
			this.sendKeepAliveRequest();
		}, DEFAULT_KEEP_ALIVE_INTERVAL_MS);
	}

	public stopKeepAlive(): void {
		clearInterval(this.intervalId);
	}

	private sendKeepAliveRequest() {
		this.loggingClient.onStartKeepAlive(this.getKeepAliveData());
	}

	private getKeepAliveData(): any {
		return {
			sessionId: this.sessionId,
			streamType: this.WebcastPlayerLogging.currentStreamTypeSignal(),
			webcastId: this.webcastId,
			runNumber: this.runNumber
		};
	}
}
